/**
 * Idiomas que maneja el traductor de librerías.
 */
export const L10N = {
  DE: 'de_DE',
  EN: 'en_US',
  ES: 'es_ES',
  FR: 'fr_FR',
  IT: 'it_IT',
  PT: 'pt_PT',
};

/** Orden de las columnas en la tabla de traducción. */
export const L10N_LIST = [L10N.DE, L10N.EN, L10N.ES, L10N.FR, L10N.IT, L10N.PT];

/**
 * Nombres en español. Los componentes los pasan por `lang.handle()`.
 */
export const L10N_NAMES = {
  [L10N.DE]: 'Alemán',
  [L10N.EN]: 'Inglés',
  [L10N.ES]: 'Español',
  [L10N.FR]: 'Francés',
  [L10N.IT]: 'Italiano',
  [L10N.PT]: 'Portugués',
};

export function getLanguageName(code) {
  return L10N_NAMES[code] ?? code;
}
